import { render } from "./Terms.vue?vue&type=template&id=9c88016e&scoped=true&ts=true&lang=pug"
import script from "./Terms.vue?vue&type=script&lang=ts&setup=true"
export * from "./Terms.vue?vue&type=script&lang=ts&setup=true"

import "./Terms.vue?vue&type=style&index=0&id=9c88016e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c88016e"]])

export default __exports__